"use client"

import styled from "@emotion/styled"
import { ProjectFilters } from "utils/projects"
import { LobbyItem } from "./FiltersUtils/filterProjects"
import LandingCard from "./LandingCard"
import ProjectCard from "./ProjectCard"

const StyledGrid = styled.div`
  display: grid;
  column-gap: 24px;
  row-gap: 40px;
  grid-template-columns: 1fr;
  ${(props) => props.theme.breakpoints.up("sm")} {
    grid-template-columns: repeat(2, 1fr);
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    grid-template-columns: repeat(3, 1fr);
  }
`

function ProjectsGrid({
  items,
  filters,
  locale,
  toProject,
  searchText,
}: {
  items: LobbyItem[]
  filters: ProjectFilters
  locale: string
  toProject: string
  searchText?: any
}) {
  return (
    <StyledGrid>
      {items.map((el, index) => {
        if (el.kind === "landing") {
          return (
            <LandingCard
              key={`landing-${el.id}-${index}`}
              locale={locale}
              landing={{
                title: el.title,
                thumbnail: el.thumbnail,
                url: el.url || undefined,
                residentialUnits: el.residentialUnits,
                city: el.city
                  ?.map((c) => filters.cities?.options?.find((o) => o.id === c.id)?.value)
                  .filter(Boolean)
                  .join(", "),
                designation: el.propertyDesignations
                  ?.map((d) => filters.designations?.options?.find((o) => o.id === d.id)?.value)
                  .filter(Boolean)
                  .join(", "),
              }}
            />
          )
        }
        return (
          <ProjectCard
            key={`${el.projectTitle} ${index.toString()}`}
            locale={locale}
            project={el}
            toProject={toProject}
            cities={filters.cities.options}
            countries={filters.countries.options}
            statuses={filters.statuses.options}
            subsidiaries={filters.subsidiaries.options}
            searchText={searchText}
            designation={filters.designations.options}
          />
        )
      })}
    </StyledGrid>
  )
}

export default ProjectsGrid
